/* eslint-disable react/prop-types */
import React, {useEffect} from 'react'
import PasswordProtect from './password-protect'
import {useGetCategorieInfo} from '../../clients/contentful'
import {useLocation} from 'react-router-dom'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

const Customs = ({children}) => {
    const navigate = useNavigation()
    const {pathname} = useLocation()
    const {data: sfCategories = []} = useGetCategorieInfo()

    useEffect(() => {
        if (pathname === '/en/' || pathname === '/en') history.replace('/')

        if (
            pathname.length > 4 &&
            !pathname?.startsWith('/fr/') &&
            !pathname?.startsWith('/en/')
        )
            navigate(pathname)

        if (pathname?.includes('/category/') && sfCategories?.length) {
            const arrURL = pathname?.split('/') || []
            const category = arrURL?.[arrURL?.length - 1]?.toUpperCase() ?? null
            const sfCategory = sfCategories?.find(
                (sfCat) => sfCat?.salesforceCategoryId === category
            )

            if (sfCategory?.slug && sfCategory?.slug !== category)
                navigate(
                    pathname?.replace(
                        `/${category.toLowerCase()}`,
                        `/${sfCategory?.slug}`
                    )
                )
        }
    }, [sfCategories, pathname])

    return <PasswordProtect>{children}</PasswordProtect>
}

export default Customs
